import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, PlayCircle, X } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { money } from "@/lib/api";

export const NAV = [
  { to: "/poetry-club", label: "Poetry Club" },
  { to: "/def-street", label: "Def Street" },
  { to: "/community", label: "Community" },
  { to: "/impact", label: "Impact" },
  { to: "/support", label: "Support" },
];

export const Logo = () => (
  <Link to="/" className="flex items-baseline gap-2 group" data-testid="nav-logo">
    <span className="font-display text-2xl tracking-tight text-ink">MAS</span>
    <span className="font-sans text-base sm:text-lg font-medium text-ink">Poetry & Literacy</span>
  </Link>
);

export const SeriesButton = ({ className = "btn-line", testid = "nav-watch-mas-series-button" }) => {
  const { settings } = useSite() || {};
  return (
    <a href={settings?.series_url || "https://masarts.link/series"} target="_blank" rel="noopener noreferrer" className={className} data-testid={testid}>
      <PlayCircle className="w-4 h-4" /> Watch MAS Series
    </a>
  );
};

const linkCls = ({ isActive }) =>
  `text-sm font-medium transition-colors hover:text-shell ${isActive ? "text-shell underline underline-offset-8 decoration-2" : "text-ink"}`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { campaign } = useSite() || {};
  return (
    <header className="sticky top-0 z-50 bg-tang">
      <div className="container-mas flex items-center justify-between h-16">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={linkCls} data-testid={`nav-link-${n.to.slice(1)}`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-2">
          <SeriesButton className="btn-ink !py-1.5 !px-4 !border-ink" />
          <Link to="/donate" className="inline-flex items-center rounded-full bg-ink text-shell px-5 py-2 text-sm font-semibold hover:bg-passion transition-colors" data-testid="nav-donate-button">Donate</Link>
        </div>
        <button className="lg:hidden p-2 text-ink" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="mobile-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {campaign && (
        <Link to="/donate" className="block bg-ink text-shell text-[11px] font-mono tracking-wider py-1.5 px-3 text-center truncate hover:text-mustard transition-colors" data-testid="nav-campaign-ribbon">
          {money(campaign.raised)} raised of {money(campaign.goal)} · <span className="text-tang">{money(campaign.remaining)} to go</span> · Give now →
        </Link>
      )}
      {open && (
        <div className="lg:hidden bg-tang border-t border-ink/20" data-testid="mobile-menu">
          <div className="container-mas py-5 flex flex-col gap-4">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} className={(p) => `${linkCls(p)} !text-xl`} data-testid={`mobile-nav-link-${n.to.slice(1)}`}>{n.label}</NavLink>
            ))}
            <div className="flex flex-col gap-3 pt-2">
              <Link to="/donate" onClick={() => setOpen(false)} className="inline-flex justify-center rounded-full bg-ink text-shell px-6 py-3 font-semibold" data-testid="mobile-donate-button">Donate</Link>
              <SeriesButton className="btn-ink" testid="mobile-watch-mas-series-button" />
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
